import React, { useState, useEffect } from "react";
import { useWeightContext } from "../context/appContext";
import RadioInput from "../../../containers/input.radio";
import ContainerWithTitle from "../../../containers/title.container";
import ButtonContainer from "../../../containers/button";

const QuestionFifteen = ({ onNext, onPrev }) => {
  const { payload, setPayload, currentPage, setCurrentPage, setErrorMessage } =
    useWeightContext();
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(payload?.eating_habits || "");
  }, [currentPage, payload]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (value) {
      onNext(value);
    } else {
      // setErrorMessage("Please select your eating habits.");
      setErrorMessage("Please select any one.");
    }
  };

  const handleRadioChange = (event) => {
    setErrorMessage(null);
    setValue(event.target.value);
    window.gtag({
      event: "user_personalized_plan",
      data: {
        personalized_plan: event.target.value,
      },
    });
    if (window.fbq) {
      window.fbq("track", "user_personalized_plan", {
        personalized_plan: event.target.value,
      });
    }
    onNext(event.target.value);
  };

  return (
    <ContainerWithTitle
      title="Are you open to a personalized product plan (~₹2000/month)?"
      handleBack={onPrev}
      isContinueButton={false}
    >
      <div className="radio-container flex lg:flex-row flex-col whitespace-pre">
        <RadioInput
          label="Yes"
          value="Yes"
          colorChecked={value === "Yes"}
          onChange={handleRadioChange}
        />
        <RadioInput
          label="Maybe"
          value="Maybe"
          colorChecked={value === "Maybe"}
          onChange={handleRadioChange}
        />
        <RadioInput
          label="No"
          value="No"
          colorChecked={value === "No"}
          onChange={handleRadioChange}
        />
      </div>
      {/* <ButtonContainer onClick={handleSubmit}>Next</ButtonContainer> */}
    </ContainerWithTitle>
  );
};

export default QuestionFifteen;
